<template>
  <div class="login-pagina d-flex align-center">
    <v-card class="rounded-xl mx-auto" width="100%" max-width="1400" style="overflow: hidden">
      <v-row no-gutters class="login-fila">
        <v-col md="6" class="login-marca d-none d-md-flex flex-column justify-center align-center pa-12">
          <v-img class="flex-grow-0" contain width="360" :aspect-ratio="5 / 1" alt="cetae"
            :src="require('../assets/cetae-logo-inverso.png')"></v-img>
          <div class="white--text text-h5 font-weight-light mt-8">Aula virtual</div>
        </v-col>
        <v-col cols="12" md="6" class="d-flex flex-column justify-center pa-6 pa-sm-10 pa-lg-16">
          <v-img class="d-md-none flex-grow-0 mb-6" contain width="140" :aspect-ratio="5 / 1" alt="cetae"
            :src="require('../assets/cetae-logo.png')"></v-img>
          <h1 class="text-h5 mb-6">Ingresar</h1>
          <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="recaptcha()">
            <div class="caption grey--text text--darken-1">{{ inputs[3].text }}</div>
            <v-chip-group v-model="inputs[3].value" mandatory column active-class="btnSuccess white--text"
              class="mb-4">
              <v-chip v-for="tipo in inputs[3].data" :key="tipo.value" :value="tipo.value">{{ tipo.text }}</v-chip>
            </v-chip-group>

            <v-text-field v-model="inputs[0].value" :rules="inputs[0].rules" :label="inputs[0].text"
              :prepend-inner-icon="inputs[0].icon" autocomplete="username" outlined
              class="rounded-lg"></v-text-field>

            <v-text-field v-model="inputs[1].value" :rules="inputs[1].rules" :label="inputs[1].text"
              :prepend-inner-icon="inputs[1].icon" autocomplete="current-password"
              :type="showPass ? 'text' : 'password'" :append-icon="showPass ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="showPass = !showPass" outlined class="rounded-lg"></v-text-field>

            <v-btn type="submit" block x-large class="white--text rounded-lg font-weight-regular" depressed
              color="btnSuccess" :loading="$store.getters.loader">Ingresar</v-btn>
          </v-form>
          <div class="d-flex flex-wrap justify-space-between mt-4">
            <v-btn @click="olvidoPass()" small text
              class="grey--text text--darken-1 text-decoration-underline font-weight-regular text-none">Olvidé mi
              contraseña</v-btn>
            <v-btn @click="olvidoUser()" small text
              class="grey--text text--darken-1 text-decoration-underline font-weight-regular text-none">Olvidé mi
              usuario</v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
// @ is an alias to /src
import MessagesRules from "../config/MessagesRules";

export default {
  name: "Login",
  // computed: {
  //   loader() {
  //     return this.$store.getters.loader;
  //   }
  // },
  data: () => ({
    valid: true,
    showPass: false,
    inputs: [
      {
        tag: "username",
        text: "Usuario",
        placeholder: "",
        icon: "mdi-account",
        required: true,
        value: "",
        type: "text",
        rules: [v => !!v || "Usuario" + MessagesRules.required],
        counter: 0
      },
      {
        tag: "password",
        text: "Contraseña",
        placeholder: "",
        icon: "mdi-lock",
        required: true,
        value: "",
        type: "password",
        rules: [v => !!v || "Contraseña" + MessagesRules.required],
        counter: 0
      },
      {
        tag: "web",
        text: "web",
        placeholder: "",
        icon: "mdi-lock",
        required: true,
        value: "true",
        type: "hidden",
        counter: 0
      },
      {
        tag: "tipoUsuario",
        text: "Tipo de Usuario",
        placeholder: "",
        icon: "mdi-account",
        required: true,
        value: "alumno",
        type: "select",
        rules: [v => !!v || "Tipo de Usuario" + MessagesRules.required],
        counter: 0,
        data: [
          { text: "Alumno", value: "alumno" },
          { text: "Profesor", value: "profesor" },
          { text: "Empresa", value: "empresa" },
          { text: "Operador", value: "operador" },
        ]
      },

    ]
  }),
  methods: {
    seguirInscripcion() {
      this.$router.push({ name: 'CargaArchivo' })
    },
    async recaptcha() {
      if (!this.$refs.form.validate()) return;
      await this.$recaptchaLoaded();
      const token = await this.$recaptcha("login");
      if (token) {
        this.login(token);
      }
    },
    async login(token_rc) {
      let that = this;
      if (this.$refs.form.validate()) {
        let loginUrl = "";
        let userType = this.inputs[3].value;
        switch (userType) {
          case "profesor":
            loginUrl = "profesor/login";
            break;
          case "alumno":
            loginUrl = "alumno/login";
            break;
          case "empresa":
            loginUrl = "empresa/login";
            break;
          case "operador":
            loginUrl = "operador/login";
            break;
        }
        await this.$API.post({
          url: loginUrl,
          data: [...that.inputs, { tag: "token_rc", value: token_rc }],
          form: true
        }).then(res => {
          let userPayload = {};

          switch (userType) {
            case "profesor":
              userPayload = {
                IDStB: res.user.id,
                Nombres: res.user.usu_nombre,
                docente: res.user.docentes,
                puntaje: res.user.puntaje,
                vendedor: res.user.vendedor,
                email: res.user.email,
                cobrador: res.user.cobrador,
                tipoUsuario: "profesor"
              };
              break;
            case "alumno":
              userPayload = {
                IDStB: res.user.IDStB,
                Nombres: res.user.Nombres,
                Apellidos: res.user.Apellidos,
                imagen: res.user.imagen,
                borrado: res.user.Borrado === '1' || res.user.alumno_mora ? '1' : '',
                borrado_real:res.user.Borrado_real,
                puntaje: res.user.puntaje,
                excedente: res.user.excedente,
                tipoUsuario: "alumno",
                kanban: res.user.kanban,
                deudaAlumno: res.user.validarDeuda.deuda,
                validacion_inscripcion:res.user.validacion_inscripcion,
                pendiente_documentos_inscripcion:res.user.validacion_inscripcion
              };
              that.$store.dispatch("tieneBadge1", res.tieneBadge1);
              that.$store.dispatch("tieneBadge2", res.tieneBadge2);
              that.$store.dispatch("tieneBadge3", res.tieneBadge3);
              that.$store.dispatch("porcentaje1", res.porcentaje1);
              that.$store.dispatch("porcentaje2", res.porcentaje2);
              that.$store.dispatch("porcentaje3", res.porcentaje3);
              that.$store.dispatch("primeroIngreso", res.primeroIngreso);
              that.$store.dispatch("carreraPrincipal", res.cursoPrincipal);
              if (res.imagenbase64 != null) {
                if (res.imagenbase64.length <= 20000) {
                  that.$store.dispatch("imagenbs", res.imagenbase64);
                } else {
                  console.warn('Imagen base64 data too large to store in localStorage');
                }
              }

              break;
            case "empresa":
              userPayload = {
                IDStB: res.user.id,
                Nombres: res.user.razon_social,
                quit: res.user.quit,
                direccion: res.user.direccion,
                telefono: res.user.telefono,
                email: res.user.email,
                responsable: res.user.responsable,
                tipoUsuario: "empresa"
              };
              break;
            case "operador":
              userPayload = {
                IDStB: res.user.id,
                Nombres: res.user.nombre,
                telefono: res.user.telefono,
                email: res.user.email,
                tipoUsuario: "operador"
              };
              break;
          }

          that.$store.dispatch("token", res.token_type + " " + res.access_token);
          that.$store.dispatch("user", userPayload);

          // Ensure all necessary data is loaded before redirecting
          that.ensureDataLoaded().then(() => {
            const storedCallback = localStorage.getItem('callback');
            if (storedCallback) {
              localStorage.removeItem('callback');
              this.$router.push(storedCallback);
            } else {
              setTimeout(() => {
                const destination = userType === 'profesor' ? 'HomeProfesor' : 'Home';
                that.$router.replace({ name: destination });
              }, 2000);
            }
          });
        });


      }
    },
    async ensureDataLoaded() {
      // Add any necessary checks or additional API calls here
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, 500); // Arbitrary delay to simulate data loading
      });
    },

    async olvidoPass() {
      this.$router.replace({ name: "ResetPassword" });
    },
    async olvidoUser() {
      this.$router.replace({ name: "RecoverUser" });
    }
  }
};
</script>
<style scoped>
/* 24px = padding vertical del v-col de App.vue (el del v-container lo anula el margen negativo del v-row) */
.login-pagina {
  min-height: calc(100vh - 24px);
}
@media (min-width: 960px) {
  .login-fila {
    min-height: 80vh;
  }
}
/* degradado: el fondo de la app también es #2D3436, sin él el panel se funde con la página */
.login-marca {
  background: linear-gradient(135deg, #4a5558 0%, #2d3436 100%);
}
</style>
